import { Paper, Stack, SxProps, Theme, useTheme } from '@mui/material';
import { ReactNode } from 'react';
import { useColumnResizer } from '../layout/columnResizer/columnResizer';
import { Resizer } from '../layout/columnResizer/resizer';

export interface PaperResizerProps {
  columnId?: string;
  initialColumnWidth?: number;
  children: ReactNode;
  color?: string;
  sx?: SxProps<Theme> | undefined;
}

/**
 * @summary Generic component containing a paper that is resizeable
 * Note that top level children are divided using MUI Divider components
 * @public
 */
export const PaperResizer = (props: PaperResizerProps) => {
  const { columnId, initialColumnWidth, children, color, sx } = props;
  const { columnWidth } = useColumnResizer(columnId, initialColumnWidth);
  const theme = useTheme();

  return (
    <Stack direction="row" sx={{ borderRight: `1px solid ${theme.palette.divider}` }}>
      <Resizer resizeColumnId={columnId} />
      <Paper
        elevation={0}
        square={true}
        sx={{
          ...sx,
          backgroundColor: color,
          display: 'flex',
          flexDirection: 'column',
          width: columnWidth
        }}>
        {children}
      </Paper>
      <Resizer resizeColumnId={columnId} />
    </Stack>
  );
};
